module.exports = __webpack_public_path__ + "static/tw-meta-img-f544bc25deb7668508a72ab958825bf5.png";